import { v4 as uuid } from "uuid";

export const categories = [
  {
    _id: uuid(),
    categoryName: "Intelligence",
    description: `Three things:
    - Strength/Aesthetics/Fitness- Knowledge/Wisdom/Intelligence- Social Skills/Machiavellianism/Game
    You want to work on all three of them.
    - You do not want to be 1/3.- You do not want to be 2/3.- You want to be 3/3.
    Don't severely neglect one.
    ~Harsh Strongman`,
  },
  {
    _id: uuid(),
    categoryName: "Social Skills",
    description: `Three things:
    - Strength/Aesthetics/Fitness- Knowledge/Wisdom/Intelligence- Social Skills/Machiavellianism/Game
    You want to work on all three of them.
    - You do not want to be 1/3.- You do not want to be 2/3.- You want to be 3/3.
    Don't severely neglect one.
    ~Harsh Strongman`,
  },
  {
    _id: uuid(),
    categoryName: "Strength",
    description: `Three things:
      - Strength/Aesthetics/Fitness- Knowledge/Wisdom/Intelligence- Social Skills/Machiavellianism/Game
      You want to work on all three of them.
      - You do not want to be 1/3.- You do not want to be 2/3.- You want to be 3/3.
      Don't severely neglect one.
      ~Harsh Strongman`,
  },
];
